// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__ij5oE","right":"styles_right__1fRWq"};